import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/HomeScreen/index.tsx");
